import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

import { Grid, Typography } from "@mui/material";

import AddNewDocument from "../../../../../containers/AddNewDocument/AddNewDocument";

import { saveLegalEntitySIs } from "../../../../../services/legal-entity-sis/legal-entity-sis-api.service";
import { handleDownloadDocsFiles } from "../../../../../services/documents";

import { DocumentDTO } from "../../../../../models/documents";

import { getFontAwesomeIconFromMIME } from "../../../../../utils/files-utils/get-font-awesome-icon-from-mime";
import { intlFormatDate } from "../../../../../utils/time-utils";
import { intlFormatDateShort } from "../../../../../utils/time-utils";

import { Props } from "./interfaces";
import { Container, Documents, Actions, FilesInfo } from "./styles";

const DocumentsCell = ({ legalEntitySI, handleNotifyParent }: Props) => {
  const handleSaveDocuments = async (document: DocumentDTO | null) => {
    if (!document) return;

    try {
      await saveLegalEntitySIs({
        ...legalEntitySI,
        documents: [...legalEntitySI.documents, document],
      });

      await handleNotifyParent();
    } catch (error) {}
  };

  return (
    <Container>
      <Documents>
        {legalEntitySI.documents.map(({ id, files }) => (
          <Grid
            key={id}
            onClick={() => handleDownloadDocsFiles([id])}
          >
            {getFontAwesomeIconFromMIME(files[0].type)}
            <Typography>{intlFormatDate(files[0].createdAt)}</Typography>
          </Grid>
        ))}
      </Documents>
      <Actions>
        <AddNewDocument
          isWidget
          buttonType="plusButton"
          handleNotifyParent={handleSaveDocuments}
          documentFieldsProps={{ legalEntity: legalEntitySI.legalEntity }}
        />
        {!!legalEntitySI.documents.length && (
          <FilesInfo>
            <FontAwesomeIcon icon={faBars} />
            <Grid>
              {legalEntitySI.documents
                .map((d) => d.files[0])
                ?.map(({ id, name, createdAt }) => (
                  <Typography key={id}>{`${name} - ${intlFormatDateShort(createdAt)}`}</Typography>
                ))}
            </Grid>
          </FilesInfo>
        )}
      </Actions>
    </Container>
  );
};

export default DocumentsCell;
